export default __webpack_public_path__ + "static/media/pdfIcon.c212fc68.svg";